import logger from '../../../services/logging/logging-service';
import { doMutation, doQuery, isGenericError, isGraphQlError } from '../../../services/graphql';
import { authStore } from '../../../global-store/subjects/auth';
import { getFailureAction } from '../../utils/get-failure-action';
import { parseErrorsGraphQL, parseDataNewsletter } from '../../utils/parsers';
import { getLabel } from '../../../labels/labelling-service';

import { getNewslettersToSubscribe } from './getters/get-newsletters-to-subscribe';

export const doWidgetQuery = ({ widget, listIds, actions, onSuccessCallback }) => {
  const auth = authStore.getValue();
  const dataParser = (dataToParse) => parseDataNewsletter({ data: dataToParse });
  return doQuery({
    query: widget.services.query,
    variables: { listIds, token: auth.userToken },
    onStart: actions?.setQueryStart,
    onFailure: (error, type) => {
      if (isGraphQlError(type)) {
        const errorObj = parseErrorsGraphQL(error);
        const failureAction = getFailureAction(actions, auth);
        const queryFailureAction = failureAction(errorObj).query;
        queryFailureAction(errorObj);
        logger.warn(`[${widget.name}] [doQuery() AppSync errors]`, error);
      }
      if (isGenericError(type)) {
        actions?.setQueryFailureGeneric(error);
        logger.warn(`[${widget.name}] [doQuery() generic error]`, error);
      }
    },
    onSuccess: (data) => {
      const parsedData = dataParser(data);
      actions?.setQuerySuccess(parsedData);
      onSuccessCallback?.();
    },
  });
};

export const doWidgetMutation = ({ widget, listId, actions, onSuccessCallback }) => {
  const auth = authStore.getValue();
  const dataParser = (dataToParse) => parseDataNewsletter({ data: dataToParse });
  return doMutation({
    mutation: widget.services.mutation,
    variables: { listId, token: auth.userToken },
    onStart: actions?.setMutationStart,
    onFailure: (error, type) => {
      if (isGraphQlError(type)) {
        const errorObj = parseErrorsGraphQL(error);
        const failureAction = getFailureAction(actions, auth);
        const mutationFailureAction = failureAction(errorObj).mutation;
        mutationFailureAction(errorObj);
        logger.warn(`[${widget.name}] [doMutation() AppSync errors]`, error);
      }
      if (isGenericError(type)) {
        actions?.setMutationFailureGeneric(error);
        logger.warn(`[${widget.name}] [doMutation() generic error]`, error);
      }
    },
    onSuccess: (data) => {
      const parsedData = dataParser(data);
      actions?.setMutationSuccess(parsedData);
      onSuccessCallback?.();
    },
  });
};

export const widgetMutationSuccessCallback = ({ widget, htmlProps, actions }) =>
  doWidgetQuery({ widget, listIds: [htmlProps.listId], actions });

export const doWidgetMutations = async ({ widget, actions, state, onSuccessCallback }) => {
  const arrayOfPromises = getNewslettersToSubscribe(state).map((newsletterToSubscribe) =>
    doWidgetMutation({
      actions,
      widget,
      listId: newsletterToSubscribe,
    })
  );
  const results = await Promise.all(arrayOfPromises);
  const allResultsAreSuccessful = results.filter((result) => Boolean(result)).length === results.length;

  // If they are not successful it could be a 401
  if (allResultsAreSuccessful) {
    onSuccessCallback?.();
  }
};

export const widgetMutationsSuccessCallback = async ({ state, actions, pageActions, widget }) => {
  const listIds = state.selectedOptionsIds;
  await doWidgetQuery({ widget, listIds, actions });
  pageActions.setNotificationStatus({
    isShown: true,
    message: getLabel('status.notification.message.set.newsletters'),
  });
  pageActions.setNotificationStatus({ isShown: false }, 3000);
};
